import type {
  AiCopyResponse,
  CabinState,
  ModelSettings,
  ScenarioDecision,
  SemanticIntentPayload,
  SemanticIntentResponse
} from "../types/domain";
import { buildFallbackCopy } from "./decisionEngine";

const storageKey = "geely-demo-model-settings";

export const defaultModelSettings: ModelSettings = {
  modelEnabled: false,
  apiKey: "",
  baseUrl: "https://api.openai.com",
  model: "gpt-5-mini"
};

export async function loadModelSettings(): Promise<ModelSettings> {
  if (window.geelyDemo) {
    return window.geelyDemo.getSettings();
  }

  try {
    const saved = localStorage.getItem(storageKey);
    return saved ? { ...defaultModelSettings, ...JSON.parse(saved) } : defaultModelSettings;
  } catch {
    return defaultModelSettings;
  }
}

export async function saveModelSettings(settings: ModelSettings): Promise<ModelSettings> {
  if (window.geelyDemo) {
    return window.geelyDemo.saveSettings(settings);
  }

  localStorage.setItem(storageKey, JSON.stringify(settings));
  return settings;
}

export async function requestDecisionCopy(
  state: CabinState,
  decision: ScenarioDecision | null,
  settings: ModelSettings
): Promise<AiCopyResponse> {
  const fallback = buildFallbackCopy(decision);

  if (!decision || !settings.modelEnabled || !window.geelyDemo) {
    return { source: "local", text: fallback };
  }

  return window.geelyDemo.generateAiCopy({
    state,
    decision,
    fallback
  });
}

export async function requestSemanticIntent(
  payload: SemanticIntentPayload,
  settings: ModelSettings
): Promise<SemanticIntentResponse | null> {
  if (!settings.modelEnabled || !window.geelyDemo?.generateSemanticIntent) {
    return null;
  }

  return window.geelyDemo.generateSemanticIntent(payload);
}
